
import { defineComponent, computed, watch, ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Actions, Mutations } from "../../../store/enums/StoreEnums";
import { isCurrentSystem } from "../../../core/helpers/unils";
import baseUrlConfig from "../../../core/config/BaseUrlConfig";
import JwtService from "../../../core/services/JwtService";
import { ApiAuth, ApiBase } from "../../../core/api";

interface User {
  id: number;
  username: string;
  email: string;
  firstname: string;
  lastname: string;
  language: string;
  advanced_manage: number;
  wms_default_warehouse: string;
  settlement_default_owner: string;
  user_type: number;
}

interface TaggingItem {
  label: string;
  value: string;
}

export default defineComponent({
  name: "kt-user-menu",
  components: {},
  setup() {
    const router = useRouter();
    const i18n = useI18n();
    const store = useStore();
    const userInfo = ref<User>();
    const baseUrl = ref();
    const options = ref<Array<TaggingItem>>([]);

    userInfo.value = store.getters.currentUser;
    baseUrl.value = baseUrlConfig.baseUrl;

    watch(
      () => store.getters.currentUser,
      (newVal) => {
        userInfo.value = newVal;
      }
    );

    i18n.locale.value = JwtService.getLang() as string;

    const countries = {
      en_US: {
        flag: require("../../../assets/media/flags/united-states.svg"),
        name: "English",
      },
      zh_CN: {
        flag: require("../../../assets/media/flags/china.svg"),
        name: "Chinese",
      },
      de_DE: {
        flag: require("../../../assets/media/flags/germany.svg"),
        name: "German",
      },
    };

    const getDropdownOptions = async () => {
      const { data } = await ApiBase.getWarehouseData({
        function_type: "1",
      });
      if (data.code == 0) {
        options.value = data.data;
      }
    };

    const signOut = () => {
      store
        .dispatch(Actions.LOGOUT)
        .then(() => router.push({ name: "sign-in" }));
    };

    const setLang = async (lang) => {
      const { data } = await ApiAuth.updateUser({
        id: userInfo.value?.id,
        language: lang,
      });
      if (data.code == 0) {
        JwtService.setLang(lang);
        i18n.locale.value = lang;
        location.reload();
      }
    };

    const currentLanguage = (lang) => {
      return i18n.locale.value === lang;
    };

    const currentLangugeLocale = computed(() => {
      return countries[i18n.locale.value];
    });

    const setWarehouse = async (warehouse: string) => {
      const { data } = await ApiAuth.updateUser({
        id: userInfo.value?.id,
        wms_default_warehouse: warehouse,
      });
      if (data.code == 0) {
        store.commit(
          Mutations.SET_USER,
          Object.assign(userInfo.value as any, {
            wms_default_warehouse: warehouse,
          })
        );
        location.reload();
      }
    };

    const currentWarehouse = (warhouse) => {
      return userInfo.value?.wms_default_warehouse === warhouse;
    };

    const getCurrentWarehouseName = computed(() => {
      let result = options.value.find(
        (item) => item.value === userInfo.value?.wms_default_warehouse
      );
      return result?.label;
    });

    onMounted(() => {
      getDropdownOptions();
    });

    return {
      options,
      currentLangugeLocale,
      countries,
      signOut,
      setLang,
      currentLanguage,
      setWarehouse,
      currentWarehouse,
      getCurrentWarehouseName,
      isCurrentSystem,
      userInfo,
      baseUrl,
    };
  },
});
